import { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SplashV2 } from '../components';
import { useAuth } from '../contexts/AuthContext';

export default function LoadingSplashPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();
  const [splashComplete, setSplashComplete] = useState(false);

  const handleSplashComplete = useCallback(() => {
    setSplashComplete(true);
  }, []);

  useEffect(() => {
    if (splashComplete && !isLoading) {
      if (isAuthenticated) {
        navigate('/home', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [splashComplete, isLoading, isAuthenticated, navigate]);

  return <SplashV2
    onComplete={handleSplashComplete}
    introDelay={4500}
    fallbackTimeout={8000} />;
}
